
export default {
  productData: {
    serialNumber: 'DA-HMS-011',
    name: 'Holzbalkendecke mit Schalldämmplatten l Aufbau 11',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '18',
          value: 'd-18'
        },
        {
          type: 'underfloorHeating',
          title: { de: 'Dämmplatte für Fußbodenheizung' },
          output: '20',
          value: 'ufh-1'
        },
        {
          type: 'soundInsulation',
          title: { de: 'Schalldämmplatte' },
          output: '2 x 15 mm',
          value: 'si-30'
        },
        {
          type: 'insulation',
          title: { de: 'Holzfaserdämmplatte WF<br>(<i>s‘</i> ≤ 24 MN/m<sup>3</sup>; Anwendungsgebiet DES-sg)' },
          output: '≥ 20',
          value: 'w-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 60 kg/m<sup>2</sup>), Rieselschutz' },
          output: '≥ 80',
          value: 'scsb-80'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '≥ 22',
          value: 22
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken' },
          output: '240',
          value: 'b-240'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Hohlraumdämpfung' },
          output: '2 x 120',
          value: 'h-240'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Federschiene' },
          output: '25',
          value: 'f-25'
        },
        {
          type: 'soundInsulation',
          title: { de: 'Schalldämmplatte' },
          output: '12,5',
          value: 'g-12.5'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Gipsplatte GK' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '480', value: 480
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '30 (2; 10)',
        value: 30
      },
      soundReductionIndex: { // Rw
        output: '84 (-3; -9)',
        value: 84
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,17',
        value: 0.17
      },
      fireResistance: {
        output: '-', value: null
      },
      massPerUnitArea: {
        output: '274,1 [kg/m²]'
      }
    }
  },
  image: 'da-hms-011.png',
  pdf: 'Holzbalkendecke-mit-Schalldämmplatten-Aufbau-11-DA-HMS-011-Rev01.pdf'
}
